/**
 * Aithyra Gallery - GLightbox Integration
 * Initializes GLightbox for all gallery elements
 */

document.addEventListener('DOMContentLoaded', function() {
    // Custom arrow SVG for GLightbox navigation
    const arrowSvg = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6968 12.9196H14.8065C15.3822 12.9196 15.7533 12.5741 15.7533 12.0496C15.7533 11.525 15.3822 11.1795 14.8065 11.1795H5.6968C5.12104 11.1795 4.75 11.525 4.75 12.0496C4.75 12.5741 5.12104 12.9196 5.6968 12.9196ZM16.7001 15.568C17.2374 15.568 17.6597 15.1586 17.6597 14.6085C17.6597 14.0583 17.2374 13.6489 16.7001 13.6489C16.1627 13.6489 15.7405 14.0583 15.7405 14.6085C15.7405 15.1586 16.1627 15.568 16.7001 15.568ZM16.7001 10.4502C17.2374 10.4502 17.6597 10.0408 17.6597 9.49065C17.6597 8.94049 17.2374 8.53107 16.7001 8.53107C16.1627 8.53107 15.7405 8.94049 15.7405 9.49065C15.7405 10.0408 16.1627 10.4502 16.7001 10.4502ZM14.8577 18.1269C15.395 18.1269 15.8172 17.7175 15.8172 17.1674C15.8172 16.6172 15.395 16.2078 14.8577 16.2078C14.3203 16.2078 13.8981 16.6172 13.8981 17.1674C13.8981 17.7175 14.3203 18.1269 14.8577 18.1269ZM14.8577 7.89134C15.395 7.89134 15.8172 7.48192 15.8172 6.93176C15.8172 6.38159 15.395 5.97217 14.8577 5.97217C14.3203 5.97217 13.8981 6.38159 13.8981 6.93176C13.8981 7.48192 14.3203 7.89134 14.8577 7.89134ZM18.5425 13.0091C19.0798 13.0091 19.5021 12.5997 19.5021 12.0496C19.5021 11.4994 19.0798 11.09 18.5425 11.09C18.0051 11.09 17.5829 11.4994 17.5829 12.0496C17.5829 12.5997 18.0051 13.0091 18.5425 13.0091Z" fill="currentColor"/></svg>';

    // Initialize GLightbox for all gallery items
    if (typeof GLightbox !== 'undefined') {
        const lightbox = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
            closeButton: true,
            zoomable: true,
            draggable: true,
            dragToleranceX: 40,
            dragToleranceY: 65,
            preload: true,
            moreLength: 0,
            slideEffect: 'slide',
            openEffect: 'zoom',
            closeEffect: 'zoom',
            skin: 'clean',
            selector: '.glightbox',
            svg: {
                prev: arrowSvg,
                next: arrowSvg
            }
        });

        console.log('GLightbox initialized successfully');
    } else {
        console.warn('GLightbox library not loaded');
    }
});
